import { memo } from 'react';

import SvgIcon from './lib/SvgIcon';

type Props = React.ComponentProps<typeof SvgIcon> & {
  fill?: string;
};

const LanguageIcon = (props: Props) => {
  const { fill, ...restProps } = props;

  return (
    <SvgIcon viewBox="0 0 12 12" {...restProps}>
      <path
        fill={fill}
        d="M11.38,3.97c-.2-.19-.44-.34-.7-.44-.26-.1-.54-.15-.83-.15h-2.13v-1.38c0-.53-.23-1.04-.63-1.42-.41-.38-.95-.59-1.53-.59H2.16C1.59,0,1.04,.21,.63,.59c-.41,.38-.63,.89-.63,1.42v3.16c0,.26,.06,.52,.16,.77,.11,.24,.27,.46,.47,.65,.41,.38,.95,.59,1.53,.59h2.13v1.38c0,.26,.05,.52,.16,.76,.11,.24,.27,.46,.47,.65,.19,.19,.43,.34,.69,.44,.26,.1,.54,.16,.82,.15h3.41c.28,0,.56-.05,.83-.15,.26-.1,.5-.25,.7-.43,.4-.38,.63-.88,.64-1.42v-3.17c0-.26-.05-.52-.16-.77-.11-.24-.27-.46-.47-.65ZM2.16,6.27c-.32,0-.62-.12-.84-.32-.22-.21-.35-.49-.35-.78V2.01c0-.15,.03-.29,.09-.43,.06-.13,.15-.26,.26-.36,.11-.1,.24-.18,.39-.24,.15-.06,.3-.08,.46-.08h3.4c.32,0,.62,.12,.84,.32,.22,.21,.35,.49,.35,.78v3.16c0,.29-.13,.57-.35,.78-.22,.21-.53,.32-.84,.33H2.16Zm8.89,2.28c0,.15-.03,.29-.09,.42-.06,.13-.15,.26-.26,.36-.11,.1-.24,.18-.39,.24-.14,.05-.3,.08-.46,.08h-3.41c-.16,0-.31-.03-.46-.08-.14-.06-.28-.14-.39-.24-.22-.21-.35-.49-.35-.78v-1.38h.31c.36,0,.71-.08,1.02-.24,.31-.16,.58-.38,.78-.66l-1.09,2.6v.05h.88l.34-.81h1.38l.35,.81h.94l-1.62-3.84h-.64l-.19,.45c0-.11,0-.22,0-.33v-.92h2.13c.16,0,.31,.03,.46,.08,.15,.06,.28,.14,.39,.24,.11,.1,.2,.23,.26,.36,.06,.13,.09,.28,.09,.43v3.17Zm-3.33-1.09l.28-.79,.2-.64,.21,.64,.26,.79h-.95Z"
      />
      <path
        fill={fill}
        d="M5.94,5.92l.4-.71-.13-.04c-.62-.14-1.21-.37-1.75-.68,.47-.49,.82-1.08,1.01-1.71h.8v-.69h-1.98l.15-.11-.1-.1c-.23-.22-.48-.42-.76-.59h-.06l-.08-.08-.61,.42,.15,.1c.14,.1,.27,.2,.39,.31l.06,.04H1.38v.69h.84c.22,.63,.56,1.21,1.02,1.71-.55,.33-1.16,.57-1.81,.68l-.17,.04,.4,.71h.11c.74-.2,1.45-.51,2.07-.94,.62,.39,1.29,.69,2,.9l.11,.04Zm-1.32-3.15c-.18,.45-.45,.86-.79,1.22-.35-.35-.62-.77-.79-1.22h1.59Z"
      />
    </SvgIcon>
  );
};

LanguageIcon.normalized = true;

export default memo(LanguageIcon);
